// extracted by mini-css-extract-plugin
export var box = "_5t-0";
export var check = "_5t-1";
export var checkboxButton = "_5t-6";
export var checkboxGroup = "_5t-5";
export var disabled = "_5t-7";
export var ghost = "_5t-9";
export var input = "_5t-2";
export var label = "_5t-4";
export var normal = "_5t-8";
export var uncheck = "_5t-3";